import { FC, useEffect, useState } from 'react';
import { AnimatedNumber } from 'components/AnimatedNumber/AnimatedNumber';
import styles from './VibePointsToast.module.css';
interface VibePointsToastProps {
  points: number;
  onClose: () => void;
}

/** Sparkle count scales with points earned: low → 20, mid → 40, high → 80 */
function getSparkleCount(points: number): number {
  if (points >= 25) return 80;
  if (points >= 15) return 40;
  return 20;
}
export const VibePointsToast: FC<VibePointsToastProps> = ({
  points,
  onClose
}) => {
  const [visible, setVisible] = useState(false);
  const sparkleCount = getSparkleCount(points);
  useEffect(() => {
    const rafId = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(rafId);
  }, []);
  return <div className={`${styles.toast} ${visible ? styles.toastVisible : ''}`} role="status" aria-live="polite" data-sentry-component="VibePointsToast" data-sentry-source-file="VibePointsToast.tsx">
      <div className={styles.sparkleField}>
        {Array.from({
        length: sparkleCount
      }, (_, i) => <span key={i} className={styles.sparkle} />)}
      </div>
      <div className={styles.iconCircle}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-source-file="VibePointsToast.tsx">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="VibePointsToast.tsx" />
        </svg>
      </div>
      <div className={styles.content}>
        <span className={styles.label}>Vibe Points Earned</span>
        <AnimatedNumber value={`+${points} VP`} duration={0.8} className={styles.points} data-sentry-element="AnimatedNumber" data-sentry-source-file="VibePointsToast.tsx" />
      </div>
      <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Dismiss">
        &times;
      </button>
    </div>;
};